const axios = require('axios');

(() => {
  const selectCampingOption = '.select-customer-camping-option'
  const checkCampingOption = '.check-customer-camping-option'

  const campingReservationClose = '.camping-reservation-close';
  const campingReservationOpen = '.camping-reservation-open';
  const campingStayInfo = '.camping-stay-info';

  const campingOptionClose = '.camping-option-close';
  const campingOptionOpen = '.camping-option-open';
  const campingOptionInfo = '.camping-option-info';

  const campingSubscriptionClose = '.camping-subscription-close';
  const campingSubscriptionOpen = '.camping-subscription-open';
  const campingSubscriptionInfo = '.camping-subscription-info';

  const init = () => {
    if (location.href.indexOf('customer/camping/option') < 1 ) {
      return
    }

    $('body').on('change', selectCampingOption, changePrice)
      .on('change', checkCampingOption, changePrice)
      .on('click', campingReservationClose, closeStayInfoContent)
      .on('click', campingReservationOpen, showStayInfoContent)
      .on('click', campingOptionClose, closeOptionInfoContent)
      .on('click', campingOptionOpen, showOptionInfoContent)
      .on('click', campingSubscriptionClose, closeSubscriptionInfoContent)
      .on('click', campingSubscriptionOpen, showSubscriptionInfoContent)
  }
  const changePrice = () => {
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/camping/option/change', 
      method: 'POST',
      data: $('form').serialize(),
      withCredentials: true,
      headers: {'X-CSRF-Token': token}
    })
    .then(response => {
      $('.plan-block-right').html(response['data'])
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const closeStayInfoContent = e => {
    $(campingReservationClose).fadeOut();
    $(campingStayInfo).fadeOut();
    $(campingReservationOpen).fadeIn();
  }

  const showStayInfoContent = e => {
    console.log('show');
    $(campingReservationClose).fadeIn();
    $(campingStayInfo).fadeIn();
    $(campingReservationOpen).fadeOut();
  }

  const closeOptionInfoContent = e => {
    $(campingOptionClose).fadeOut();
    $(campingOptionInfo).fadeOut();
    $(campingOptionOpen).fadeIn();
  }

  const showOptionInfoContent = e => {  
    $(campingOptionClose).fadeIn();
    $(campingOptionInfo).fadeIn();
    $(campingOptionOpen).fadeOut();
  }
  
  const closeSubscriptionInfoContent = e => {
    $(campingSubscriptionClose).fadeOut();
    $(campingSubscriptionInfo).fadeOut();
    $(campingSubscriptionOpen).fadeIn();
  }

  const showSubscriptionInfoContent = e => {
    $(campingSubscriptionClose).fadeIn();
    $(campingSubscriptionInfo).fadeIn();
    $(campingSubscriptionOpen).fadeOut();
  }
  
  $(init);

  $(init)
})();
